import { deleteCookie } from '@/utils/cookieUtils';
import { SHOPBY_ACCESSTOKEN, SHOPBY_REFRESHTOKEN, SESSION_INITIALIZE, TOKEN_EXPIRE_TIME } from '@/const/words/cookie';
import { api } from '@/api';
import store from '@/store';

const { VUE_APP_NODE_ENV, VUE_APP_ADMIN_REMOTE_URL, VUE_APP_COMMERCE_AUTH, VUE_APP_PREMIUM_ADMIN_URL } = process.env

export const deleteAuthInfoToLogOut = () => {
  deleteCookie(SHOPBY_ACCESSTOKEN);
  deleteCookie(SHOPBY_REFRESHTOKEN);
  deleteCookie(SESSION_INITIALIZE);
  deleteCookie(TOKEN_EXPIRE_TIME);

  window.localStorage.removeItem('adminInfo');
  window.localStorage.removeItem('menuInfo');
  window.localStorage.removeItem('mallInfo');
};

const logoutIntegrationAccount = () => {
  deleteAuthInfoToLogOut();
  //NOTE : 통합 계정 로그아웃 = uri넘기는 병렬방식으로
  const commerceUri = `${encodeURIComponent(`${VUE_APP_COMMERCE_AUTH}/logout?continue=${VUE_APP_PREMIUM_ADMIN_URL}/login`)}`;
  const commerceAccountLogoutUri = `${VUE_APP_ADMIN_REMOTE_URL}/logout?redirectUrl=${encodeURIComponent(
    `${VUE_APP_PREMIUM_ADMIN_URL}/logout.html?redirectUri=${commerceUri}`
  )}`;

  window.open(commerceAccountLogoutUri, '_self');
};

const logoutGeneralAccount = async (skipApi = false) => {
  if (!skipApi) {
    try {
      await api.postPrivacyAccessHistories({
        data: {
          menu: 'LOGOUT',
          workingType: 'LOGOUT',
        },
      } as any);
    }
    catch (e) {
      console.error(e);
    }
  }

  deleteAuthInfoToLogOut();
  window.location.href = `${VUE_APP_ADMIN_REMOTE_URL}/logout?redirectUrl=${encodeURIComponent(
    `${VUE_APP_PREMIUM_ADMIN_URL}/login`
  )}`;
};

export const logout = async (skipApi = false) => {
  try {
    store.getters['admin/admin']?.isMasterAdmin && VUE_APP_NODE_ENV !== 'local'
      ? logoutIntegrationAccount()
      : logoutGeneralAccount(skipApi);
  } catch (err) {
    console.error(err);
  }
};
